export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1883347a42798a201596cd5d1b30a731.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 py-20 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Left Column - Main Content */}
          <div className="lg:col-span-5">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <p className="text-white text-sm font-light">Programmazione Informatica dal 2016</p>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-bold text-white leading-[1.1] mb-6">
              SOLUZIONI<br />
              DIGITALI<br />
              INNOVATIVE
            </h1>
            
            <p className="text-white/90 text-lg font-light leading-relaxed mb-10 max-w-lg">
              Sviluppiamo software personalizzati e sistemi IT avanzati per trasformare il vostro business
            </p>
            
            <button
              onClick={() => scrollToSection('servizi')}
              className="inline-flex items-center gap-3 bg-[#1A4D4D] text-white px-8 py-4 rounded-full font-medium hover:bg-[#2D5F5F] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Scopri i Servizi
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* Center Column - Main Image */}
          <div className="lg:col-span-4 hidden lg:block">
            <div className="relative h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%203D%20software%20interface%20design%20with%20floating%20UI%20elements%2C%20holographic%20technology%20displays%2C%20futuristic%20dashboard%20screens%2C%20clean%20minimalist%20aesthetic%2C%20teal%20and%20dark%20color%20scheme%2C%20professional%20business%20software%20visualization%2C%20abstract%20digital%20workspace%2C%20contemporary%20tech%20illustration%2C%20depth%20and%20layers%2C%20sophisticated%20corporate%20design&width=600&height=800&seq=hero-center-lios-002&orientation=portrait"
                alt="Software Interface"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right Column - Credentials */}
          <div className="lg:col-span-3 space-y-6">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-white font-bold text-xl">Perché Lios</h3>
                <i className="ri-arrow-right-up-line text-white text-xl"></i>
              </div>
              
              <div className="space-y-3">
                <div className="relative h-32 rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20IT%20team%20collaboration%20in%20modern%20office%2C%20experienced%20software%20developers%20working%20together%2C%20business%20meeting%20with%20technology%20focus%2C%20corporate%20expertise%20and%20professionalism%2C%20contemporary%20workspace%20environment%2C%20team%20synergy%20and%20innovation%2C%20clean%20professional%20photography&width=400&height=200&seq=hero-exp-lios-003&orientation=landscape"
                    alt="Esperienza"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm p-3">
                    <p className="text-[#2C2C2C] font-semibold text-sm">Esperienza Consolidata</p>
                  </div>
                </div>
                
                <div className="grid grid-cols-2 gap-3">
                  <div className="relative h-28 rounded-xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20IT%20certifications%20and%20quality%20badges%2C%20technology%20standards%20symbols%2C%20corporate%20excellence%20awards%2C%20business%20credentials%20display%2C%20modern%20minimalist%20design%2C%20trust%20and%20reliability%20visual%2C%20professional%20achievement%20icons%2C%20clean%20background&width=200&height=200&seq=hero-cert-lios-004&orientation=squarish"
                      alt="Certificazioni"
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm p-2">
                      <p className="text-[#2C2C2C] font-semibold text-xs">Certificazioni</p>
                    </div>
                  </div>
                  
                  <div className="relative h-28 rounded-xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Qualified%20IT%20professionals%20team%20portrait%2C%20skilled%20software%20engineers%20and%20developers%2C%20expert%20technology%20specialists%2C%20professional%20business%20team%20photo%2C%20corporate%20expertise%20visualization%2C%20modern%20office%20setting%2C%20competent%20workforce%20representation&width=200&height=200&seq=hero-team-lios-005&orientation=squarish"
                      alt="Team"
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm p-2">
                      <p className="text-[#2C2C2C] font-semibold text-xs">Team Qualificato</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
